export enum PromotionAudienceType {
    Account = "Account",
    User = "User",
}
